module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Little-Drummer-Girl.e786a36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Little-Drummer-Girl.jpg
// module id = kbL9
// module chunks = 0